export default __webpack_public_path__ + "static/media/icon-192x192.d4bb12b9.png";